import { guaguaCategories } from "@/mocks/guagua";

export default function Categories() {
  return (
    <section id="categories" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <p className="text-xs md:text-sm font-medium tracking-wide text-primary-500">📂 总有一款瓜对上你</p>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl text-foreground-950">
            吃瓜分类 · 按兴趣围观
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">
            不管是宿舍夜聊、课堂名场面还是食堂奇遇，都能在这里找到组织，快乐加倍。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {guaguaCategories.map((cat) => (
            <a
              href="#feed"
              key={cat.id}
              className="group overflow-hidden rounded-2xl bg-background-100 border border-background-200 transition-colors hover:border-accent-300"
            >
              <div className="relative h-44 md:h-48 w-full overflow-hidden">
                <img
                  src={cat.img}
                  alt={`校园吃瓜分类：${cat.name}${cat.slogan}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 flex h-9 w-9 items-center justify-center rounded-full bg-background-50/90 text-lg">
                  {cat.emoji}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-lg text-foreground-950 group-hover:text-primary-700 transition-colors">
                    {cat.name}
                  </h3>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{(cat.count / 100).toFixed(1)}k+ 帖子</span>
                </div>
                <p className="mt-1.5 text-xs md:text-sm text-foreground-700 line-clamp-1">{cat.slogan}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-sm text-primary-600 whitespace-nowrap">
                  进去看看
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}